/**
 * Studio SHACL rule table — consumer-owned rules injected into the
 * Repository's `ShaclRuleRegistry`.
 *
 * Per `docs/agentic/architecture/kg-repository-usage.md` §2.4, each client
 * app ships its own rule table. Studio imports the **generated** rule set
 * (compiled from `cogo-ns-v1.ttl` via `@cogo/kg-repository`'s
 * `compile-shacl` script — Phase 2 §5.1 #6).
 *
 * IRI prefix matches `cogo-ns-v1.ttl` (`https://cogo.xyz/ns/v1#`) — baked
 * into the generated SPARQL.
 *
 * Regenerate upstream:
 *   pnpm --filter @cogo/kg-repository compile-shacl
 *
 * Studio-specific rule additions (not covered by the ontology yet) can be
 * appended to `STRUCTURAL_RULES` / `BINDING_RULES` below; keep them small +
 * well-commented + annotated with the intended upstream target.
 */

import type { ShaclQueryRule } from '@cogo/kg-browser'
import {
  COGO_NS_V1_STRUCTURAL_RULES,
  type ValidationPhase,
} from '@cogo/kg-repository'

/** Structural-phase rules — generated from `cogo-ns-v1.ttl` (320+ rules). */
const STRUCTURAL_RULES: readonly ShaclQueryRule[] = COGO_NS_V1_STRUCTURAL_RULES

/** Binding-phase rules — post-bindExample checks. Empty in v1. */
const BINDING_RULES: readonly ShaclQueryRule[] = []

/** Phase → rule table. Wraps into `MapBackedRuleRegistry` at provider mount. */
export const STUDIO_SHACL_RULES: Record<ValidationPhase, readonly ShaclQueryRule[]> = {
  structural: STRUCTURAL_RULES,
  binding: BINDING_RULES,
}
